import { Link } from "react-router-dom";
import { Lock, Instagram, Mail } from "lucide-react";
import { Logo } from "@/components/Logo";
import { scrollToId } from "@/components/Hero";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/10 bg-cosmic-base pt-16 pb-8">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-3">
            <Logo size={42} />
            <span className="font-display text-2xl font-black text-white">
              Cosmic<span className="text-gradient-candy">Cloudz</span>
            </span>
          </div>
          <p className="mt-5 max-w-sm text-sm text-slate-400 leading-relaxed">
            Handcrafted artisanal cotton candy in 16 deep-space flavors. Containers for pickup,
            bulk premium tubs, and live event spinning with unlimited cones — every cloud spun fresh.
          </p>
          <div className="mt-6 flex gap-3">
            <a data-testid="footer-instagram" href="https://instagram.com" target="_blank" rel="noopener noreferrer"
              className="rounded-full glass p-3 text-slate-300 transition-colors hover:text-cosmic-pink" aria-label="Instagram">
              <Instagram size={17} />
            </a>
            <a data-testid="footer-email" href="mailto:hello@cosmiccloudz.cc"
              className="rounded-full glass p-3 text-slate-300 transition-colors hover:text-cosmic-cyan" aria-label="Email">
              <Mail size={17} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400">Explore</h4>
          <ul className="mt-5 space-y-3 text-sm">
            {[["Flavors", "#flavors", "footer-link-flavors"], ["Live Events", "#packages", "footer-link-packages"],
              ["Event Estimator", "#calculator", "footer-link-calculator"], ["Gallery", "#gallery", "footer-link-gallery"]].map(([label, href, tid]) => (
              <li key={href}>
                <button data-testid={tid} onClick={() => scrollToId(href)} className="text-slate-300 transition-colors hover:text-cosmic-cyan">
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400">How to Order</h4>
          <ul className="mt-5 space-y-3 text-sm text-slate-300">
            <li>1. Build your order or pick a package</li>
            <li>2. Submit the request — we confirm fast</li>
            <li>3. Pay with Cash, Zelle, Card, Cash App, Venmo, or Apple Pay</li>
          </ul>
          <div className="mt-5 flex flex-wrap gap-2">
            {["Cash", "Zelle", "Card", "Cash App", "Venmo", "Apple Pay"].map((p) => (
              <span key={p} className="rounded-full border border-white/10 bg-white/5 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.1em] text-slate-300">
                {p}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-14 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/10 pt-6">
        <p className="text-xs text-slate-500">© {new Date().getFullYear()} Cosmic Cloudz. Spun with stardust.</p>
        <Link data-testid="footer-admin-link" to="/admin"
          className="flex items-center gap-1.5 text-xs text-slate-500 transition-colors hover:text-cosmic-cyan">
          <Lock size={12} /> Owner Login
        </Link>
      </div>
    </div>
  </footer>
);

export default Footer;
